import type { ReviewItemDto } from '../../../shared/api';
import { esc, money } from '../format';

export const reviewLabel = (r: ReviewItemDto) =>
  r.kind === 'limit' ? 'Not read: daily limit reached' : r.kind === 'held' ? 'Alert from a sender you added' : "Couldn't read this alert";

/** A Review item on the New purchases card: label, amount if known, two actions. */
export function reviewRow(r: ReviewItemDto): string {
  return `<div class="askrow"><div class="askhead"><span>${reviewLabel(r)}</span><span>${r.amountCents ? money(r.amountCents, 2) : ''}</span></div>
  <div class="chips"><button class="chip" data-a="review-add" data-id="${esc(r.id)}">Add details</button><button class="chip" data-a="review-dismiss" data-id="${esc(r.id)}">Dismiss</button></div></div>`;
}
